module.exports = __webpack_public_path__ + "static/media/verification.b22a23f2.png";